export default __webpack_public_path__ + "67826ff53ec3c131b3902248cf3c0716.ply";